// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-367b913e] {\n  font-size: 15px;\n}[dir] .badge[data-v-367b913e] {\n  padding: 6px;\n}\n.chip-custom[data-v-367b913e] {\n  font-size: 12px;\n  color: #ffb300;\n}\n[dir] .chip-custom[data-v-367b913e] {\n  margin-top: 10px;\n  background: #fff5df;\n  border-radius: 10px;\n  padding: 4px 8px;\n}\n", ""]);
// Exports
module.exports = exports;
